export default __webpack_public_path__ + "static/media/job_offer16_m.5cf62fd3.jpg";